import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { UserAccountQueryEndpoint } from '@api/endpoints/UserAccountQueryEndpoint';
import { UserInspectorEndpoint } from '@api/endpoints/UserInspectorEndpoint';

export class UserInspectorApi {
  static getUserData (
    userAccountId: string,
    query: UserInspectorEndpoint.GetUserData.Query = {},
  ): Promise<UserInspectorEndpoint.GetUserData.Response> {
    const qs = QueryUtil.stringify(query);
    return Client(`admin/user-inspector/${encodeURIComponent(userAccountId)}?${qs}`);
  }

  static getTableRows (
    body: UserInspectorEndpoint.GetTableRows.Request,
  ): Promise<UserInspectorEndpoint.GetTableRows.Response> {
    return Client('admin/user-inspector/rows', { body, method: 'POST' });
  }

  static queryUserAccounts (
    body: UserAccountQueryEndpoint.Query.Request,
  ): Promise<UserAccountQueryEndpoint.Query.Response> {
    return Client('admin/user-accounts/query', { body, method: 'POST' });
  }
}
